import { createContext } from 'react';

export interface AppContextType {
    successfulMessage: string | undefined;
    setSuccessfulMessage: (successfulMessage: string | undefined) => void;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);
